import React, { useEffect } from "react";
import useFetch from "@/lib/useFetch";
import { GlassCard, PageTitle, EmptyState } from "@/components/lux";
import api from "@/lib/api";
import { Bell, CheckCircle2, XCircle, Info } from "lucide-react";

const iconFor = (k) => (k === "success" ? CheckCircle2 : k === "error" ? XCircle : Info);
const colorFor = (k) => (k === "success" ? "text-emerald-400" : k === "error" ? "text-rose-400" : "text-blue-400");

export default function Notifications() {
  const { data, loading, reload } = useFetch("/user/notifications");
  useEffect(() => { api.post("/user/notifications/read").catch(() => {}); }, []);
  return (
    <div className="space-y-6">
      <PageTitle title="Notifications" subtitle="Your account alerts and updates" />
      <GlassCard className="p-6">
        {loading ? <div className="skeleton h-40" /> : data?.notifications?.length ? (
          <div className="space-y-3">
            {data.notifications.map((n, i) => {
              const Icon = iconFor(n.kind);
              return (
                <div key={i} className="flex items-start gap-3 rounded-xl glass-2 p-4" data-testid={`notif-${i}`}>
                  <Icon size={18} className={`mt-0.5 shrink-0 ${colorFor(n.kind)}`} />
                  <div className="flex-1">
                    <p className="font-medium text-white">{n.title}</p>
                    <p className="text-sm text-[var(--text-dim)]">{n.body}</p>
                  </div>
                  <span className="text-xs text-[var(--text-dim)]">{(n.created_at || "").slice(0, 16).replace("T", " ")}</span>
                </div>
              );
            })}
          </div>
        ) : <EmptyState icon={Bell} title="No notifications" />}
      </GlassCard>
    </div>
  );
}
